module.exports = __webpack_public_path__ + "static/media/722JettStNW_2018-06-05_31.d82f85f6.jpg";